/**
 * Copyright (C), 2012-2018, Sichuan Xiaoka Technology Co., Ltd.
 * */
/**
 *  MQTT
 */
import { connect } from 'mqtt';
import init from './init';

let pahoMqtt = null;
const terminal = process.env.terminal; // 终端
const emqttOptions = {
  host: process.env.MQTT_HOST,
  port: process.env.MQTT_PORT || '', // 端口
  protocol: process.env.MQTT_PROTOCOL, // 协议
  protocolVersion: 4, // 协议版本
  path: '/mqtt', // 路径URI
  hostname: '', // 主机名
  username: '', // 用户名,WS不用传
  password: '', // 密码,WS不用传
  clientId: '', // 连接客户端ID,必须唯一,相同的ID,新连接的会将旧连接强制下线,建议于登录的用户ID关系
  clean: false, // 设置为false以在脱机时接收QoS1和2消息
  keepalive: 2, // 心跳【秒】
  connectTimeout: 5 * 1000, // 连接超时时间【毫秒】
  reconnectPeriod: 3 * 1000, // 两次重连之间的间隔时间【毫秒】
  will: { // 当连接断开时，代理发送的连接配置，主要测试连接是否可用
    topic: '/will',
    payload: 'dieout',
    qos: 1,
    retain: true
  }
};

let userInfo = init.state.userInfo;
const state = {
  MQTT_CONNECT_STATUS: false, // mqtt 的连接状态
  MQTT_CILENT: '', // mqtt 实例
  tpcs: [], // 主题集
  sendTpcs: [],// 发送的主题
  DRIVER_MESSAGE: null, // 司机位置更新
  ALL_MESSAGE: null // 全局消息
};

const mutations = {
  // 创建MQTT 连接
  MQTT_CONNECT(state, params) {
    if (!state.MQTT_CONNECT_STATUS) {
      if (terminal === 'h5') {
        emqttOptions['clientId'] = `${userInfo.id}-${new Date().valueOf()}`;
        state.MQTT_CILENT = connect(emqttOptions);
        console.log('MQTT 开始连接！');
        state.MQTT_CILENT.on('connect', (e) => {
          console.log('MQTT 连接成功！');
          state.MQTT_CONNECT_STATUS = true;
          params.fn(true);
        });
        state.MQTT_CILENT.onMessageArrived = (message) => {
          console.log('订阅断开' + message.payloadString);
          state.MQTT_CONNECT_STATUS = false;
        };
        // 消息处理
        state.MQTT_CILENT.on('message', function (topic, message, packet) {
          // message是一个buffer,所以我们需要把它toString
          message = message.toString();
          console.log(topic, message);
          if (topic.includes(`${userInfo.project}_${userInfo.num}_driver_${userInfo.companyId}`)) {
            state.DRIVER_MESSAGE = null;
            if (message) {
              state.DRIVER_MESSAGE = JSON.parse(message);
            }
          } else if (topic.includes(`${userInfo.project}_${userInfo.num}_message_${userInfo.companyId}`)) {
            state.ALL_MESSAGE = null;
            if (message) {
              state.ALL_MESSAGE = JSON.parse(message);
            }
          }
        });
      }
    }
  },
  // 添加 MQTT 订阅
  MQTT_NEW_TOPIC(state, params) {
    let subscribeFn = () => {
      if (state.MQTT_CONNECT_STATUS) { // 是否连接上
        params = Object.assign({ tpc: ``, qos: 0 }, params); // tpc 配置
        if (!state.tpcs.find(tpcItem => tpcItem === params.tpc)) {
          state.MQTT_CILENT.subscribe(params.tpc, { qos: params.qos });
          state.tpcs.push(params.tpc);
          console.log(`添加订阅：【  ${params.tpc}  】`);
        } else {
          console.log(`订阅存在：【  ${params.tpc}  】`);
        }
      } else {
        console.log('添加订阅：失败');
        setTimeout(() => {
          subscribeFn();
        }, 5000);
      }
    };
    subscribeFn();
  },
  // 向 MQTT 订阅 推送 信息
  MQTT_PUBLISH_TOPIC(state, obj) {
    if (state.MQTT_CONNECT_STATUS) { // 是否连接上
      if (terminal === 'h5') { // h5
        state.MQTT_CILENT.publish(obj.topic, obj.message, obj.opt);
      } else {
        let message = new pahoMqtt.Message(obj.message);
        message.destinationName = obj.topic;
        state.MQTT_CILENT.send(message);
      }
      // console.log('向【' + obj.topic + '】订阅推送：' + obj.message)
      if (obj.fn) {
        obj.fn(true);
      }
    }
  },
  // 取消 MQTT 订阅
  MQTT_CANCEL_TOPIC(state, obj) {
    let tpc = obj.topic + window.configure.AppKey + (obj.companyId ? ('/' + (obj.companyId || '')) : '') + (obj.userId ? ('/' + (obj.userId || '')) : '');
    state.MQTT_CILENT.unsubscribe(tpc, function (err) {
      if (err) {
        console.log('取消订阅【' + tpc + '】错误 : ', err);
        if (obj.fn) {
          obj.fn(false);
        }
      } else {
        console.log('取消订阅：【' + tpc + '】');
        state.tpcs.splice(state.tpcs.findIndex(item => item === tpc), 1);
        if (obj.fn) {
          obj.fn(true);
        }
      }
    });
  }
};

const getters = {
  MQTT_CILENT: state => state.MQTT_CILENT,
  MQTT_CONNECT_STATUS: state => state.MQTT_CONNECT_STATUS,
  DRIVER_MESSAGE: state => state.DRIVER_MESSAGE, // 代驾司机 定位推送
  ALL_MESSAGE: state => state.ALL_MESSAGE // 全局的消息推送
};

const actions = {
  // 创建MQTT 连接
  async MQTT_CONNECT({ commit }, params = {}) {
    return new Promise(resolve => {
      params['fn'] = (state) => {
        if (state) {
          resolve(state);
        }
      };
      commit('MQTT_CONNECT', params);
    });
  },
  // 添加 MQTT 订阅
  MQTT_NEW_TOPIC({ commit }, params = {}) {
    return new Promise(resolve => {
      params['fn'] = (state) => {
        if (state) {
          resolve();
        }
      };
      commit('MQTT_NEW_TOPIC', params);
    });
  },
  // 取消 MQTT 订阅
  MQTT_CANCEL_TOPIC({ commit }, params = {}) {
    return new Promise(resolve => {
      params['fn'] = (state) => {
        if (state) {
          resolve();
        }
      };
      commit('MQTT_CANCEL_TOPIC', params);
    });
  },
  // 向 MQTT 订阅 推送 信息
  MQTT_PUBLISH_TOPIC({ commit }, params = {}) {
    return new Promise(resolve => {
      params['fn'] = (state) => {
        if (state) {
          resolve();
        }
      };
      commit('MQTT_PUBLISH_TOPIC', params);
    });
  }
};

export default {
  name: 'mqtt',
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/module/mqtt.js